var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleCloudLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 155 155",
    width: "144px",
    height: "144px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #4caf50;\n      }\n\n      .cls-2 {\n        fill: #ff3d00;\n      }\n\n      .cls-3 {\n        fill: #ffc107;\n      }\n\n      .cls-4 {\n        fill: #1976d2;\n      }\n\n      .cls-5 {\n        fill: #ffe082;\n      }\n\n      .cls-5, .cls-6 {\n        isolation: isolate;\n        opacity: .5;\n      }\n\n      .cls-6 {\n        fill: #90caf9;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M130.6,59c-2.9-10.3-8.7-19.4-16.5-26.4l-17.2,17.2c6.3,5.1,10.5,12.7,11.3,21.2v5.7c0,0,.2,0,.3,0,8.7,0,15.8,7.1,15.8,15.8s-7.1,15.8-15.8,15.8-.2,0-.3,0h0s-25,0-25,0h-5.8v24.4h30.8c0,0,.2,0,.3,0,22.1,0,40.2-18,40.2-40.2s-7.2-26.3-18-33.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M60.8,86.2l17.7-17.7s0,0,0,0l-17.7,17.7s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M60.8,86.2l17.7-17.7s0,0,0,0l-17.7,17.7s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M77.4,18.6c-30.5,0-55.3,24.8-55.3,55.3s0,1.7.1,2.6h24.4c0-.9-.1-1.7-.1-2.6,0-17.1,13.9-30.9,30.9-30.9s14.2,2.6,19.5,6.9l17.2-17.2c-9.8-8.7-22.6-14.1-36.7-14.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M46.3,108.3h0c-2.3,0-4.5-.5-6.4-1.4l-17.7,17.7c6.7,5.1,15,8.1,24.1,8.1h31.1v-24.4h-31.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46.3,108.3h0c-2.3,0-4.5-.5-6.4-1.4l-17.7,17.7c6.7,5.1,15,8.1,24.1,8.1h31.1v-24.4h-31.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M30.5,92.5c0-8.7,7.1-15.8,15.8-15.8s11.9,3.8,14.4,9.4l17.7-17.7c-7.4-9.8-19-16-32.1-16-22.1,0-40.2,18-40.2,40.2s6.3,24.7,16.1,32l17.7-17.7c-5.5-2.5-9.4-8-9.4-14.4Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleCloudLarge);
export default __webpack_public_path__ + "static/media/google-cloud_large.7676ba43bc5f1fe5a3c76e30b6563444.svg";
export { ForwardRef as ReactComponent };